import type { ReactNode } from 'react';

import PrimaryButton from '@/components/ui/Button/PrimaryButton';

type MainSliderButtonLinkProps = {
  href?: string;
  className?: string;
  children: ReactNode;
  ariaLabel?: string;
};

const MainSliderButtonLink = ({
  href,
  className,
  children,
  ariaLabel,
}: MainSliderButtonLinkProps) => (
  <PrimaryButton
    data={{
      title: typeof children === 'string' ? children : undefined,
      link: href,
    }}
    className={className}
    ariaLabel={ariaLabel}
  />
);

export default MainSliderButtonLink;
